(() => {
  const ready = (fn) => {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  ready(() => {
    const toggle = document.querySelector('[data-menu-toggle]');
    const nav = document.querySelector('[data-nav]');
    if (toggle && nav) {
      toggle.addEventListener('click', () => {
        const open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    const reveals = document.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && reveals.length) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );
      reveals.forEach((el) => io.observe(el));
    } else {
      reveals.forEach((el) => el.classList.add('is-visible'));
    }

    initCollectionFilters();
  });

  function initCollectionFilters() {
    const layout = document.querySelector('[data-collection-layout]');
    if (!layout) return;

    const facets = document.querySelector('[data-facets]');
    const backdrop = document.querySelector('[data-facets-backdrop]');
    const openBtn = document.querySelector('[data-facets-open]');
    const closeBtn = document.querySelector('[data-facets-close]');
    const sortSelect = document.querySelector('[data-sort-select]');

    const setOpen = (open) => {
      if (!facets) return;
      facets.classList.toggle('is-open', open);
      if (backdrop) {
        backdrop.hidden = !open;
      }
      document.body.style.overflow = open ? 'hidden' : '';
    };

    openBtn?.addEventListener('click', () => setOpen(true));
    closeBtn?.addEventListener('click', () => setOpen(false));
    backdrop?.addEventListener('click', () => setOpen(false));

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    const jsFilters = document.querySelector('[data-js-filters]');
    if (!jsFilters) return;

    const cards = Array.from(document.querySelectorAll('[data-product-card]'));
    const typeInputs = Array.from(jsFilters.querySelectorAll('[data-filter-type]'));
    const allInput = jsFilters.querySelector('[data-filter-type="all"]');
    const stockInput = jsFilters.querySelector('[data-filter-availability="in-stock"]');
    const resetBtn = jsFilters.querySelector('[data-filter-reset]');
    const empty = document.querySelector('[data-filter-empty]');
    const countEl = document.querySelector('[data-results-count]');

    const apply = () => {
      const selectedTypes = typeInputs
        .filter((input) => input.dataset.filterType !== 'all' && input.checked)
        .map((input) => input.dataset.filterType);

      if (allInput) {
        allInput.checked = selectedTypes.length === 0;
      }

      const onlyStock = Boolean(stockInput?.checked);
      let visible = 0;

      cards.forEach((card) => {
        const type = card.dataset.productType || '';
        const available = card.dataset.available === 'true';
        const typeOk = selectedTypes.length === 0 || selectedTypes.includes(type);
        const stockOk = !onlyStock || available;
        const show = typeOk && stockOk;
        card.hidden = !show;
        if (show) visible += 1;
      });

      if (empty) empty.hidden = visible > 0;
      if (countEl) {
        countEl.textContent =
          visible === 1 ? '1 product' : `${visible} products`;
      }
    };

    typeInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.dataset.filterType === 'all' && input.checked) {
          typeInputs.forEach((other) => {
            if (other !== input) other.checked = false;
          });
        } else if (input.checked && allInput) {
          allInput.checked = false;
        }
        apply();
      });
    });

    stockInput?.addEventListener('change', apply);
    resetBtn?.addEventListener('click', () => {
      typeInputs.forEach((input) => {
        input.checked = input.dataset.filterType === 'all';
      });
      if (stockInput) stockInput.checked = false;
      apply();
    });

    apply();
  }
})();
